import { Box } from '@mui/material';
import type { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
    getTemplateDataFromCode,
    getTemplateDataFromTemplateFormId,
} from '@/services/ClientSideTemplateFormService';
import ClientErrorPage from './QuoteIntakeClientView/ClientErrorPage';

export default function LinkRedirectPage() {
    const { sixDigitIdentifier } = useParams();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [error, setError] = useState<AxiosError | null>(null);

    useEffect(() => {
        const run = async () => {
            if (!sixDigitIdentifier) {
                return;
            }
            try {
                const quoteParamResp = await getTemplateDataFromCode(sixDigitIdentifier);

                if (!quoteParamResp?.data?.templateFormId) {
                    return;
                }
                const templateFormResp = await getTemplateDataFromTemplateFormId(
                    quoteParamResp?.data?.templateFormId,
                );

                if (pathname.includes('/q/')) {
                    navigate(
                        `/quote/view/${quoteParamResp.data?.templateFormId}/${quoteParamResp.data?.lawFirmId}`,
                    );
                }
                if (pathname.includes('/i/')) {
                    navigate(
                        `/intake/view/${quoteParamResp.data?.templateFormId}/${quoteParamResp.data?.lawFirmId}?lawyerName=${templateFormResp?.data?.fullName}&lawyerEmail=${templateFormResp?.data?.email}&lawyerPhone=${templateFormResp?.data?.phoneNumber}&templateType=IntakeOnly`,
                    );
                }
            } catch (error: unknown) {
                console.error(error);
                setError(error as AxiosError);
            }
        };
        run();
    }, [sixDigitIdentifier, pathname, navigate]);

    return error ? (
        <ClientErrorPage />
    ) : (
        <Box
            sx={{
                width: '100%',
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        ></Box>
    );
}
